/*
    This slider is based on the "data-slide-element-index" attribute to allow sliders built with different parts like "ingredient and related product" section.

    Accepts:
    – nodeIdToInjectActiveIndex: String – Node id in which active slide index will be injected (optional)
 */

class SimpleSlider extends HTMLElement {
    activeIndex = 0;
    lastSlideIndex = 0;

    prevSlideButton = null;
    nextSlideButton = null;

    nodeToInjectActiveIndex = null;
    allSlides = [];
    allSlideDots = [];

    constructor() {
        super();

        this.setNextSlide = this.setNextSlide.bind(this);
        this.setPrevSlide = this.setPrevSlide.bind(this);
    }

    connectedCallback() {
        if (this.dataset.nodeIdToInjectActiveIndex) {
            this.nodeToInjectActiveIndex = document.querySelector(`#${this.dataset.nodeIdToInjectActiveIndex}`)
        }

        this.allSlides = Array.from(this.querySelectorAll('[data-slide-element-index]'));
        const slideIndexesArray = this.allSlides.map((slide) => parseInt(slide.dataset.slideElementIndex))
        this.allSlideDots = this.querySelectorAll('.slider-counter__slide-dot')

        this.lastSlideIndex = Math.max(...slideIndexesArray);

        this.prevSlideButton = this.querySelector('.slider__slide-prev-button');
        this.nextSlideButton = this.querySelector('.slider__slide-next-button');

        this.prevSlideButton.addEventListener('click', this.setPrevSlide)
        this.nextSlideButton.addEventListener('click', this.setNextSlide)
    }

    setNextSlide() {
        if (this.activeIndex + 1 > this.lastSlideIndex) {
            const newIndex = 0

            this.activeIndex = newIndex;
            this.setActiveIndexToNode(newIndex);
            this.setActiveSlideClassNameByIndex(newIndex);
        } else {
            const newIndex = this.activeIndex + 1;

            this.activeIndex = newIndex;
            this.setActiveIndexToNode(newIndex);
            this.setActiveSlideClassNameByIndex(newIndex);
        }
    }

    setPrevSlide() {
        if (this.activeIndex - 1 < 0) {
            const newIndex = this.lastSlideIndex;

            this.activeIndex = newIndex;
            this.setActiveIndexToNode(newIndex);
            this.setActiveSlideClassNameByIndex(newIndex);
        } else {
            const newIndex = this.activeIndex - 1;

            this.activeIndex = newIndex;
            this.setActiveIndexToNode(newIndex);
            this.setActiveSlideClassNameByIndex(newIndex);
        }
    }

    setActiveIndexToNode(index) {
        if (this.nodeToInjectActiveIndex) {
            this.nodeToInjectActiveIndex.dataset.activeIndex = String(index);
        }
    }

    setActiveSlideClassNameByIndex(activeSlideIndex) {
        this.allSlides.forEach((slide) => String(activeSlideIndex) === slide.dataset.slideElementIndex ? slide.classList.add('slider__slide--active') : slide.classList.remove('slider__slide--active'));
        this.allSlideDots.forEach((slideDot) => String(activeSlideIndex) === slideDot.dataset.slideDotIndex ? slideDot.classList.add('slider-counter__slide-dot--active') : slideDot.classList.remove('slider-counter__slide-dot--active'));
    }

    disconnectedCallback() {
        this.prevSlideButton.removeEventListener('click', this.setPrevSlide)
        this.nextSlideButton.removeEventListener('click', this.setNextSlide)
    }
}

customElements.define('simple-slider', SimpleSlider);
